import React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Checkbox from '@mui/material/Checkbox';
import ProspectRow from './ProspectRow';

const HEADERS = ['Contato', 'Onde falar', 'Situação', 'Último contato', ''];

const headerCellSx = { fontWeight: 600, color: 'text.secondary', fontSize: '0.8125rem', whiteSpace: 'nowrap' };

/**
 * ProspectsTable - Catálogo da Prospecção (Admin Geral)
 * @param {Object} props
 * @param {Array} props.items
 * @param {boolean} props.isLoading
 * @param {string|null} props.error
 * @param {boolean} [props.selectable] false esconde a coluna de marcar (grupo sem ação em lote)
 * @param {number[]} [props.selectedIds]
 * @param {Function} [props.onToggle] recebe o id
 * @param {Function} [props.onToggleAll] recebe true para marcar todos os com WhatsApp
 * @param {Function} props.onMessage
 * @param {Function} props.onEdit
 */
function ProspectsTable({ items, isLoading, error, selectable = true, selectedIds = [], onToggle, onToggleAll, onMessage, onEdit }) {
  const withWhatsApp = items.filter((item) => item.whatsapp);
  const selectedCount = withWhatsApp.filter((item) => selectedIds.includes(item.id)).length;
  const allSelected = withWhatsApp.length > 0 && selectedCount === withWhatsApp.length;
  const colSpan = HEADERS.length + (selectable ? 1 : 0);

  return (
    <Paper
      sx={{
        borderRadius: '12px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        border: '1px solid #E8ECF0',
        overflow: 'hidden',
      }}
    >
      {error && (
        <Alert severity="error" sx={{ borderRadius: 0 }}>
          {error}
        </Alert>
      )}

      <TableContainer sx={{ boxShadow: 'none', borderRadius: 0, overflowX: 'auto' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: '#F8F9FC' }}>
              {selectable && (
                <TableCell padding="checkbox">
                  <Checkbox
                    size="small"
                    checked={allSelected}
                    indeterminate={selectedCount > 0 && !allSelected}
                    disabled={withWhatsApp.length === 0}
                    onChange={() => onToggleAll(!allSelected)}
                    inputProps={{ 'aria-label': 'Selecionar todos com WhatsApp' }}
                  />
                </TableCell>
              )}
              {HEADERS.map((label, index) => (
                <TableCell key={label || `col-${index}`} sx={headerCellSx}>{label}</TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={colSpan} align="center" sx={{ py: 6 }}>
                  <CircularProgress size={32} />
                </TableCell>
              </TableRow>
            ) : items.length === 0 ? (
              <TableRow>
                <TableCell colSpan={colSpan} align="center" sx={{ py: 6 }}>
                  <Typography variant="body2" color="text.secondary">
                    Nenhum contato. Use "Novo contato" para começar.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              items.map((item) => (
                <ProspectRow
                  key={item.id}
                  item={item}
                  selected={selectedIds.includes(item.id)}
                  selectable={selectable}
                  onToggle={onToggle}
                  onMessage={onMessage}
                  onEdit={onEdit}
                />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default ProspectsTable;
